import { api } from '@/fsd/shared/api';
import { IGeneralProductsResponse } from '../../model/types/IGeneralProductsResponce';

export const getProducts = async (): Promise<IGeneralProductsResponse> => {
  const data = await api.post<IGeneralProductsResponse>(
    `/api/v1/general/products/`
  );

  return data;
};
